import React from 'react';
import Box from '@mui/material/Box';
import { useColors, useColorMode } from '../theme/ColorModeContext';

const noiseTexture = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

const PageBackground = () => {
    const colors = useColors();
    const { mode } = useColorMode();
    const isDark = mode === 'dark';

    return (
        <Box sx={{
            position: 'fixed',
            inset: 0,
            pointerEvents: 'none',
            zIndex: 0,
            overflow: 'hidden',
            background: colors.bg.primary,
        }}>
            <Box sx={{
                position: 'absolute',
                inset: 0,
                opacity: isDark ? 0.16 : 0.28,
                backgroundImage: isDark
                    ? `linear-gradient(rgba(255,255,255,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.045) 1px, transparent 1px)`
                    : `linear-gradient(rgba(12,12,20,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(12,12,20,0.035) 1px, transparent 1px)`,
                backgroundSize: '72px 72px',
                maskImage: 'linear-gradient(180deg, black 0%, transparent 78%)',
                WebkitMaskImage: 'linear-gradient(180deg, black 0%, transparent 78%)',
            }} />

            <Box sx={{
                position: 'absolute',
                inset: 0,
                background: isDark
                    ? 'linear-gradient(135deg, rgba(185,28,28,0.10) 0%, transparent 32%), linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.025) 100%)'
                    : 'linear-gradient(135deg, rgba(185,28,28,0.06) 0%, transparent 30%), linear-gradient(180deg, rgba(12,12,20,0.035) 0%, transparent 36%)',
            }} />

            <Box sx={{
                position: 'absolute',
                inset: 0,
                opacity: isDark ? 0.035 : 0.018,
                backgroundImage: noiseTexture,
                backgroundSize: '256px 256px',
            }} />

            <svg
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: isDark ? 0.22 : 0.16 }}
                viewBox="0 0 1440 900"
                preserveAspectRatio="xMidYMid slice"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <g fill="none" stroke={colors.accent.cyan} strokeWidth="1">
                    <path d="M1008 72H1408V130H1340V188H1440" />
                    <path d="M72 742H356V806H472" />
                    <path d="M1184 690H1384V824" />
                </g>
                <g fill="none" stroke={colors.border.default} strokeWidth="1">
                    <path d="M1020 84H1140V130H1248" />
                    <path d="M84 754H204V794H312" />
                    <path d="M1204 710H1298V792" />
                </g>
            </svg>
        </Box>
    );
};

export default PageBackground;
